export default __webpack_public_path__ + "static/media/illi7.2c09bc9f.png";